// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Command$SmartcutsMacros = require("./Command.bs.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var LoopCommand$SmartcutsMacros = require("./commands/LoopCommand.bs.js");
var ModifierKeys$SmartcutsMacros = require("./commands/shared/ModifierKeys.bs.js");
var SwitchCommand$SmartcutsMacros = require("./commands/SwitchCommand.bs.js");
var UploadCommand$SmartcutsMacros = require("./commands/UploadCommand.bs.js");
var DownloadCommand$SmartcutsMacros = require("./commands/DownloadCommand.bs.js");
var PasswordCommand$SmartcutsMacros = require("./commands/PasswordCommand.bs.js");
var ContextMenuCommand$SmartcutsMacros = require("./commands/ContextMenuCommand.bs.js");
var ClickToOAuthCommand$SmartcutsMacros = require("./commands/ClickToOAuthCommand.bs.js");
var GoogleSheetsCommand$SmartcutsMacros = require("./commands/GoogleSheetsCommand.bs.js");
var WithElementGroupsCommand$SmartcutsMacros = require("./commands/WithElementGroupsCommand.bs.js");
var ScreenshotToClipboardCommand$SmartcutsMacros = require("./commands/ScreenshotToClipboardCommand.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("./InterfaceBtwnRecordingAndPlayback.bs.js");
var PasteImageInContentEditableCommand$SmartcutsMacros = require("./commands/PasteImageInContentEditableCommand.bs.js");

function createStyledLogger(logger, css) {
  return function (s) {
    return Curry._2(logger.log2, "%c" + s, css);
  };
}

function createYellowLogger(logger) {
  return createStyledLogger(logger, "background: #222; color: #bada55");
}

function logCommandWithContextLocal(logger, commandWithContextLocal) {
  var command = commandWithContextLocal.command;
  if (typeof command === "number") {
    switch (command) {
      case /* ReloadCommand */0 :
          return Util$SmartcutsMacros.logAndRaiseJsError("reload command should be detected on server, not detected in client and sent to server");
      case /* ForwardCommand */1 :
          return Curry._1(logger.log1, "Go forward");
      case /* BackCommand */2 :
          return Curry._1(logger.log1, "Go back");
      
    }
  } else {
    switch (command.TAG | 0) {
      case /* URLCommand */6 :
          return Curry._2(logger.log2, "URL", command._0.url);
      case /* OpenedLinkCommand */7 :
          var match = command._0;
          var maybeOpenerTab = match.maybeOpenerTab;
          return Curry._2(logger.logMany, "WaitForNav", {
                      hd: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(match.tabRef),
                      tl: {
                        hd: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.stringify(match.windowRef),
                        tl: {
                          hd: match.url,
                          tl: {
                            hd: maybeOpenerTab !== undefined ? InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(maybeOpenerTab) : "undefined",
                            tl: /* [] */0
                          }
                        }
                      }
                    });
      case /* SubmitFormCommand */8 :
          return Curry._2(logger.log2, "Post-form-submission navigation to URL", command._0.url);
      case /* SubmitFormRedirectCommand */9 :
          return Curry._2(logger.log2, "Form Redirect to URL", command._0.url);
      case /* ClientRedirectCommand */10 :
          return Curry._2(logger.log2, "Client Javascript Redirect to URL", command._0.url);
      case /* ServerRedirectCommand */11 :
          return Curry._2(logger.log2, "Server Redirect to URL", command._0.url);
      case /* ClickCommand */12 :
          var match$1 = command._0;
          var querySelectors = Selector$SmartcutsMacros.stringify(undefined, false, match$1.domElementIdentifierWithSelector.selector);
          return Curry._4(logger.log4, "Click - query selectors: ", querySelectors, "; modifier=", ModifierKeys$SmartcutsMacros.stringify(match$1.modifierKeys));
      case /* TypeCommand */15 :
          var match$2 = command._0;
          var querySelectors$1 = Selector$SmartcutsMacros.stringify(undefined, false, match$2.domElementIdentifierWithSelector.selector);
          return Curry._4(logger.log4, "Typed: ", match$2.labeledTextInputValueDiff, " ; query selectors: ", querySelectors$1);
      case /* CheckboxCommand */16 :
          return Curry._2(logger.log2, "Typed: ", command._0);
      case /* SelectCommand */17 :
          var match$3 = command._0;
          var querySelectors$2 = Selector$SmartcutsMacros.stringify(undefined, false, match$3.domElementIdentifierWithSelector.selector);
          return Curry._4(logger.log4, "Typed: ", match$3.labeledSelectInputValue, " ; query selectors: ", querySelectors$2);
      case /* RadioCommand */18 :
          var match$4 = command._0;
          var querySelectors$3 = Selector$SmartcutsMacros.stringify(undefined, false, match$4.domElementIdentifierWithSelector.selector);
          return Curry._4(logger.log4, "Typed: ", match$4.radioInputParam, " ; query selectors: ", querySelectors$3);
      case /* DownloadCommand */32 :
          return Curry._1(logger.log1, Curry._1(DownloadCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
      case /* GoogleSheetsCommand */33 :
          return Curry._1(logger.log1, Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
      case /* ContextMenuCommand */34 :
          return Curry._1(logger.log1, Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
      case /* LoopCommand */35 :
          return Curry._1(logger.log1, LoopCommand$SmartcutsMacros.CommandValue.stringify(command._0));
      case /* SwitchCommand */36 :
          return Curry._1(logger.log1, SwitchCommand$SmartcutsMacros.CommandValue.stringify(Command$SmartcutsMacros.stringifyRecordingCommand, command._0));
      case /* ScreenshotToClipboardCommand */37 :
          return Curry._1(logger.log1, Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
      case /* PasteImageInContentEditableCommand */38 :
          return Curry._1(logger.log1, Curry._1(PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
      case /* PasswordCommand */39 :
          return Curry._1(logger.log1, Curry._1(PasswordCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
      case /* ClickToOAuthCommand */40 :
          return Curry._1(logger.log1, Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
      case /* UploadCommand */41 :
          return Curry._1(logger.log1, Curry._1(UploadCommand$SmartcutsMacros.CommandValue.Recording.stringify, command._0));
      case /* WithElementGroupsCommand */43 :
          return Curry._1(logger.log1, Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.stringify, command._0));
      default:
        return ;
    }
  }
}

exports.createStyledLogger = createStyledLogger;
exports.createYellowLogger = createYellowLogger;
exports.logCommandWithContextLocal = logCommandWithContextLocal;
/* Util-SmartcutsMacros Not a pure module */
